"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoWhile = void 0;
var tslib_1 = require("tslib");
var timer_1 = require("./timer");
var DoWhile = /** @class */ (function () {
    function DoWhile(_a) {
        var _b = _a.timeoutInMs, timeoutInMs = _b === void 0 ? null : _b, _c = _a.intervalsInMs, intervalsInMs = _c === void 0 ? 0 : _c, _d = _a.breakCondition, breakCondition = _d === void 0 ? function () { return false; } : _d, _e = _a.renewRequest, renewRequest = _e === void 0 ? function (req) { return req; } : _e;
        this.timeoutInMs = timeoutInMs;
        this.intervalsInMs = intervalsInMs;
        this.renewRequest = renewRequest;
        this.breakCondition = breakCondition;
    }
    DoWhile.prototype.wrapExecutionOf = function (fn) {
        var _this = this;
        var timer = null;
        if (this.timeoutInMs) {
            timer = new timer_1.Timer(this.timeoutInMs);
            timer.start();
        }
        return function (request) { return _this.run(request, fn, timer); };
    };
    DoWhile.prototype.run = function (request, fn, timer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, newRequest, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (timer && timer.hasTimeoutExpired()) {
                            timer.stop();
                            return [2 /*return*/, Promise.reject(DoWhile.TIMEOUT_ERROR)];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fn(request)];
                    case 2:
                        response = _a.sent();
                        if (this.breakCondition(response)) {
                            if (timer && !timer.hasTimeoutExpired()) {
                                timer.stop();
                            }
                            return [2 /*return*/, Promise.resolve(response)];
                        }
                        return [4 /*yield*/, (0, timer_1.delay)(this.intervalsInMs)];
                    case 3:
                        _a.sent();
                        newRequest = this.renewRequest(request, response);
                        return [2 /*return*/, this.run(newRequest, fn, timer)];
                    case 4:
                        error_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(error_1)];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DoWhile.TIMEOUT_ERROR = new Error("Timeout expired.");
    DoWhile.create = function (fn, params) { return new DoWhile(params).wrapExecutionOf(fn); };
    return DoWhile;
}());
exports.DoWhile = DoWhile;
